import React from 'react';

const rebrandingCloseIcon = ({ classname }: { classname?: string }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        className={classname}
    >
        <path
            d="M8.82807 9.99981L2.50684 16.321L3.68535 17.4996L10.0066 11.1783L16.3279 17.4996L17.5064 16.3211L11.1851 9.99981L17.5064 3.67851L16.3279 2.5L10.0066 8.8213L3.68535 2.50007L2.50684 3.67858L8.82807 9.99981Z"
            fill="#161719"
        />
    </svg>
);

export default rebrandingCloseIcon;
